import React from 'react'
import { SUPPORTED_LANGUAGES } from '../../i18n'
import useI18n from '../../i18n/useI18n'
import { getFlagSrc } from './flag'
import './index.scss'

const LanguageSwitcher = () => {
  const { i18n, t } = useI18n()
  const [open, setOpen] = React.useState(false)

  const currentLang = SUPPORTED_LANGUAGES.find((lang) => lang.code === i18n.language) || SUPPORTED_LANGUAGES[0]
  const alternativeLangs = SUPPORTED_LANGUAGES.filter((lang) => lang.code !== currentLang.code)
  const getLanguageLabel = (code) => t(`COMMON_LANGUAGES_${code.toUpperCase()}`)

  const handleChange = (code) => {
    if (code === i18n.language) {
      setOpen(false)
      return
    }
    i18n.changeLanguage(code)
    setOpen(false)
  }

  return (
    <div className="language-switcher">
      <button
        type="button"
        className="language-switcher__trigger"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-label={getLanguageLabel(currentLang.code)}
      >
        <img
          src={getFlagSrc(currentLang.code)}
          alt={getLanguageLabel(currentLang.code)}
          className="language-switcher__flag"
        />
      </button>

      {open && (
        <div className="language-switcher__dropdown" role="menu">
          {alternativeLangs.map((lang) => (
            <button
              key={lang.code}
              type="button"
              className="language-switcher__option"
              onClick={() => handleChange(lang.code)}
              aria-label={getLanguageLabel(lang.code)}
            >
              <img
                src={getFlagSrc(lang.code)}
                alt={getLanguageLabel(lang.code)}
                className="language-switcher__flag"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default LanguageSwitcher

